module.exports = __webpack_public_path__ + "static/media/hospitalThumbnail.7f50756e.jpg";